
import ClickOutside from "vue-click-outside";
import { path } from "ramda";

export default {
  directives: { ClickOutside },

  props: {
    featureTag: { type: Object, required: true },
    selectedFeatureTagId: { type: String, required: true },
  },

  computed: {
    imgProps() {
      const img = path(["tag_image"], this.featureTag);
      const imgDimensions = path(["dimensions"], img);

      return {
        src: path(["url"], img),
        alt: path(["alt"], img),
        ...this.getImageDimensions(imgDimensions, 90),
      };
    },
  },

  methods: {
    hideTooltip(e) {
      if (
        (!e.target.closest(".tooltip") &&
          !e.target.closest(".feature-info-icon")) ||
        e.target.closest(".close-feature-dialog")
      ) {
        this.$emit("close-feature-tile");
      }
    },
    handleTileClick() {
      this.$emit("select-feature-tile", this.featureTag.tag_id);
    },
  },
};
